import { ShapeRombus } from "@/shapeStorage/shapes/basic/rombus";

export class ShapeGateWay extends ShapeRombus {}
